import { NgModule } from '@angular/core';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { WrapperPageModule } from 'src/app/components/wrapper-page/wrapper-page.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { CurrentTenantComponent } from './current-tenant/current-tenant.component';
import { CampaignsComponent } from './current-tenant/tenant-options/campaigns/campaigns.component';
import { SettingsEditorComponent } from './current-tenant/tenant-options/settings-editor/settings-editor.component';
import { TenantOptionsComponent } from './current-tenant/tenant-options/tenant-options.component';
import { TenantDashboardComponent } from './dashboard/dashboard.component';
import { TenantRoutingModule } from './tenant-routing.module';
import { IngestionComponent } from './current-tenant/tenant-options/ingestion/ingestion.component';
import { IngestionItemDetailComponent } from './current-tenant/tenant-options/ingestion/ingestion-item-detail/ingestion-item-detail.component';

@NgModule({
    imports: [
        AppSharedModule,
        TenantRoutingModule,
        PipesModule,
        NgJsonEditorModule ,
        WrapperPageModule,

    ],
    declarations: [
        CurrentTenantComponent,
        TenantOptionsComponent,
        TenantDashboardComponent,
        SettingsEditorComponent,
        CampaignsComponent,
        IngestionComponent,
        IngestionItemDetailComponent
    ],
    exports: [
    ]
})
export class TenantModule {

}
